<div class="wrapper">
    <div class="main-panel w-100">
        <div class="content">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>

